/**
 * PortalState.js
 *
 * Copyright (c) apploft. GmbH
 */

import handleAuthorize from './Authorize/handleAuthorize';
import handleAuthorized from './Authorize/handleAuthorized';

// States

import {unauthorized, authorizing} from './PortalStateSymbol';

// Events

import {
  authorize,
  authorizationSucceeded,
  authorizationFailed,
} from './PortalEventSymbol';

function init() {
  return {
    state: unauthorized,
  };
}

function reducer({state, data, controller}, {event, payload}) {
  switch (state) {
    case unauthorized:
      switch (event) {
        case authorize:
          return handleAuthorize(payload);

        default:
          break;
      }

      break;

    case authorizing:
      controller.abort();

      switch (event) {
        case authorizationFailed:
          return {state: unauthorized};

        case authorizationSucceeded:
          return handleAuthorized(payload);

        default:
          break;
      }

      break;

    default:
      break;
  }

  return {state, data, controller};
}

export {init, reducer};
